import React, { createContext, useContext, useEffect, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {

    const [id, setId] = useState('');
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [modulos, setModulos] = useState('');
    const [rol, setRol] = useState('');
    const [token, setToken] = useState('');
    const [isLogged, setIsLogged] = useState(false);

    useEffect(() => {
        //obtener los datos del localStorage
        const idxd = localStorage.getItem('id');
        const nombrexd = localStorage.getItem('nombre');
        const emailxd = localStorage.getItem('email');
        const telefonoxd = localStorage.getItem('telefono');
        const modulosxd = localStorage.getItem('modulos');
        const rolxd = localStorage.getItem('rol');
        const isLoggedxd = localStorage.getItem('isLogged');
        const tokenxd = localStorage.getItem('token');
        if (idxd) {
            setId(idxd);
            setNombre(nombrexd);
            setEmail(emailxd);
            setTelefono(telefonoxd);
            setModulos(modulosxd);
            setRol(rolxd);
            setIsLogged(isLoggedxd);
            setToken(tokenxd)
        }
    }, []);

    useEffect(() => {
        // Guardar los datos en el localStorage
        localStorage.setItem('id', id);
        localStorage.setItem('nombre', nombre);
        localStorage.setItem('email', email);
        localStorage.setItem('telefono', telefono);
        localStorage.setItem('modulos', modulos);
        localStorage.setItem('rol', rol);
        localStorage.setItem('isLogged', isLogged);
        localStorage.setItem('token', token)

    }, [id, nombre, email, telefono, modulos, rol, isLogged, token]);

    const iniciarSesion = (id, nombre, email, telefono, modulos, rol) => {
        //console.log('iniciarSesion');
        //console.log("data: " + id + " " + nombre + " " + email + " " + telefono + " " + modulos + " " + rol + " " + isLogged);
        setId(id);
        setNombre(nombre);
        setEmail(email);
        setTelefono(telefono);
        setModulos(modulos);
        setRol(rol);
        setIsLogged(true);
    };

    const cerrarSesion = () => {
        //console.log('cerrarSesion');
        //console.log("data: " + id + " " + nombre + " " + email + " " + telefono + " " + modulos + " " + rol + " " + isLogged);
        setId('');
        setNombre('');
        setEmail('');
        setTelefono('');
        setModulos('');
        setRol('');
        setToken('');
        setIsLogged(false);
        setToken('')
    };

    return (
        <UserContext.Provider
            value={
                {
                    id,
                    nombre,
                    email,
                    telefono,
                    modulos,
                    rol,
                    isLogged,
                    token,
                    setToken,
                    iniciarSesion,
                    cerrarSesion
                }
            }>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    return useContext(UserContext);
};